import {gql} from 'apollo-angular';

export const GET_GAME_TIMERS_SCHOOL = gql`
  query GetGameTimersSchool($schoolId: Int!) {
    getGameTimersSchool(schoolID: $schoolId) {
      id
      schoolClassID
      startAt
      endAt
    }

  }
`;
